export default __webpack_public_path__ + "static/media/CNo.85-6.6fde0702.jpg";